import axios from "axios";
import { handleActions } from "redux-actions";

import Config from "config";
import { getHeaders } from "helpers/headers";
import { AnyAction } from "interfaces/action";
import { Dispatch } from "interfaces/dispatch";
import { ThunkActionCreator } from "interfaces/thunk";

/* ---------------- Types ---------------- */

export interface StoreItem {
  store_id: number;
  store_name: string;
  chain_id: number;
  retail_store_num: string;
}

export interface ReportStore {
  state_name: string;
  stores: StoreItem[];
}

export interface ReportStoresResponse {
  baseProjectId: number;
  comparisonProjectId: number | null;
  commonStores: ReportStore[];
}

export interface ReportStoresState {
  error: boolean;
  loading: boolean;
  content: ReportStoresResponse | null;
}

/* ---------------- Action Types ---------------- */

const FETCH_REPORT_STORES_REQUEST = "FETCH_REPORT_STORES_REQUEST";
const FETCH_REPORT_STORES = "FETCH_REPORT_STORES";
const FETCH_REPORT_STORES_FAILED = "FETCH_REPORT_STORES_FAILED";

export {
  FETCH_REPORT_STORES_REQUEST,
  FETCH_REPORT_STORES,
  FETCH_REPORT_STORES_FAILED,
};

/* ---------------- API Call ---------------- */

const fetchReportStores: ThunkActionCreator = (baseProject:number,comparisonProject:any) =>
  (dispatch: Dispatch) => {
    const baseProjectId  = baseProject;
    const  comparisonProjectId:any = comparisonProject
    dispatch({ type: FETCH_REPORT_STORES_REQUEST });

    return axios
      .get(
        `${Config.API_SERVICE_URL}/api/reports/stores/${baseProjectId}/${comparisonProjectId}`,
        getHeaders(),
      )
      .then((response) =>
        dispatch({
          type: FETCH_REPORT_STORES,
          payload: response.data || null,
        })
      )
      .catch((error: Error) => {
        console.error("Error fetching report stores:", error);
        dispatch({ type: FETCH_REPORT_STORES_FAILED });
      });
  };

export { fetchReportStores };

/* ---------------- Reducer ---------------- */

const initialState: ReportStoresState = {
  loading: false,
  error: false,
  content: null,
};

const actions = {
  [FETCH_REPORT_STORES_REQUEST]: (
    state: ReportStoresState
  ): ReportStoresState => ({
    ...state,
    loading: true,
    error: false,
  }),

  [FETCH_REPORT_STORES]: (
    state: ReportStoresState,
    action: AnyAction
  ): ReportStoresState => ({
    ...state,
    loading: false,
    content: action.payload,
  }),

  [FETCH_REPORT_STORES_FAILED]: (
    state: ReportStoresState
  ): ReportStoresState => ({
    ...state,
    loading: false,
    error: true,
    content: null,
  }),
};

export default handleActions<ReportStoresState, AnyAction>(
  actions,
  initialState
);
